import React from "react";
import { Link } from "react-router-dom";

import Loading from "ui/Loading";
import Panel from "ui/Panel";
import PanelSection from "ui/PanelSection";
import { useRoutes } from "utils/routes";

import { useMemberAlertDestinationsQuery } from "./gql/Query.generated";

// The alert destinations a member receives e-mail alerts through (read-only).
function MemberAlertDestinations({
  organizationSlug,
  membershipId,
}: {
  organizationSlug: string;
  membershipId: string;
}) {
  const { organizationAlertDestination } = useRoutes();
  const { data, loading, error } = useMemberAlertDestinationsQuery({
    variables: { membershipId },
  });
  if (loading || error || !data) {
    return <Loading error={!!error} />;
  }

  const { userIsSelf, alertDestinations } =
    data.getOrganizationMembershipDetails;

  return (
    <Panel title="Alert Destinations">
      <PanelSection>
        {alertDestinations.length === 0 ? (
          <div className="text-[#606771]">
            {userIsSelf
              ? "You are not subscribed to any e-mail alert destinations."
              : "This member is not subscribed to any e-mail alert destinations."}
          </div>
        ) : (
          <>
            <p>
              {userIsSelf
                ? "You are subscribed by e-mail to the following alert destinations:"
                : "This member is subscribed by e-mail to the following alert destinations:"}
            </p>
            <ul className="mt-1 list-disc pl-5">
              {alertDestinations.map((destination) => (
                <li key={destination.id}>
                  <Link
                    to={organizationAlertDestination(
                      organizationSlug,
                      destination.id,
                    )}
                  >
                    {destination.name}
                  </Link>
                </li>
              ))}
            </ul>
          </>
        )}
      </PanelSection>
    </Panel>
  );
}

export default MemberAlertDestinations;
